import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaginate, ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

interface IRequestParams {
  [key: string]: any;
  searchString?: string | number;
  rowsPerPage: number | string;
  operacao: string;
  numeroPagina?: string | number;
  tipoUsuario?: number | string;
}

@Injectable()

export class UsuarioMultiplanProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }
  
  getUsuariosAd() : Promise<Array<string>> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'usuariomultiplan?operacao=usuariosad';

      me.http.get(url, {headers: this.header}).subscribe((result: Array<string>) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getMultiplanUsers(params: IRequestParams): Promise<{data: any[]}> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'usuariomultiplan';

      me.http.get(url, {headers: this.header, params}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getPaginated(paginacao: ApiPaginate, filtroPerfil: string, filtroLojistaShopping: string, filtroLojistaLoja: string, filtroContratoLojista: string = null) : Promise<ApiPaginateResult> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'usuariomultiplan?operacao=page&' + paginacao.geraAPIUrl();

      // if(filtroPerfil != "") {
        // url += "&perfil=" + filtroPerfil;
      // }

      // if(filtroLojistaShopping != "") {
        // url += "&shopping=" + filtroLojistaShopping;
      // }

      // if(filtroLojistaLoja != "") {
        // url += "&loja=" + filtroLojistaLoja;
      // }

      var pURL = new URL(url);

      pURL.searchParams.set("loja", filtroLojistaLoja);
      pURL.searchParams.set("shopping", filtroLojistaShopping);
      pURL.searchParams.set("perfil", filtroPerfil);

      if (filtroContratoLojista) {
        pURL.searchParams.set("contrato", filtroContratoLojista);
      }

      me.http.get(pURL.toString(), {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  /**
   * Lista usuários
   * @param filtro filtro de nome ou cpf do usuário
   * @returns 
   */
  get(tipoUsuario:any,filtro:any, pagina:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {

      var filtroTipo='';
      if (tipoUsuario){
        filtroTipo='&tipoUsuario=' + tipoUsuario;
      }
      let url = APIService.API_URL + 'usuariomultiplan?searchString=' + filtro + '&numeroPagina=' + pagina + '&objetosPorPagina=1000' + filtroTipo;
      
      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData[0].status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta dos usuários.'
              }
              me.itemret=errodatavazio;
            }
            
            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns 
   */
  addupdate(dadosJson:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      var requestData=JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'usuariomultiplan';

      if(dadosJson.isEdit) {
        url += "?isEdit=1";
      }

      //console.log(requestData);
      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  
  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns 
   */
  ativarDesativarUsuarioLojista(usuario) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'usuariomultiplan?operacao=bloquear';

      me.http.post(url, usuario,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson,
            'status':error.status
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }
  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns 
   */
  ativarDesativarMFAUsuarioLojista(usuario) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'usuariomultiplan?operacao=ativarmfa';

      me.http.post(url, usuario,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }



  delete(id:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'usuariomultiplan?id=' + id;
      
      me.http.delete(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  
  

}
